import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FiArrowLeft, FiHome } from 'react-icons/fi';

export default function NotFound() {
  return (
    <>
      <Helmet><title>404 Page Not Found | Avivan Enterprises</title></Helmet>
      <div style={{
        minHeight: '100vh',
        background: 'var(--gradient-hero)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '40px 20px',
      }}>
        <div>
          <div style={{ fontSize: '8rem', lineHeight: 1, marginBottom: 24, opacity: 0.4 }}>404</div>
          <h1 style={{ color: '#fff', fontWeight: 900, fontSize: 'clamp(1.6rem, 4vw, 2.4rem)', marginBottom: 14 }}>
            Page Not Found
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: 440, margin: '0 auto 36px', lineHeight: 1.75 }}>
            The page you're looking for doesn't exist. It may have been moved, deleted, or you entered the wrong URL.
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => window.history.back()} className="btn-outline-white">
              <FiArrowLeft size={16} /> Go Back
            </button>
            <Link to="/" className="btn-accent-c">
              <FiHome size={16} /> Go to Home
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
